function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".b{fill:#757575}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#d3d3d3",
  strokeMiterlimit: 10,
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("rect", {
  width: 30,
  height: 20,
  rx: 2,
  stroke: "none"
}),
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 19,
  rx: 1.5,
  fill: "none"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-5 -28.886)"
},
/*#__PURE__*/
React.createElement("path", {
  className: "b",
  d: "M8.481 32.394h5.685a.42.42 0 100-.841H8.481a.42.42 0 000 .841zM8.481 34.269h7.615a.42.42 0 100-.841H8.481a.42.42 0 000 .841zM17.669 34.316a.471.471 0 10-.475-.467.471.471 0 00.475.467zM32.156 44.339a.393.393 0 00-.356-.42H8.236a.426.426 0 000 .841H31.8a.393.393 0 00.356-.421zM31.736 45.778h-8.208a.42.42 0 100 .841h8.208a.42.42 0 100-.841z"
}),
/*#__PURE__*/
React.createElement("circle", {
  className: "b",
  cx: 0.467,
  cy: 0.467,
  r: 0.467,
  transform: "translate(21.434 45.732)"
}),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(25.505 31.891)"
},
/*#__PURE__*/
React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  transform: "translate(-3.505 -.505)",
  fill: "#00857c"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M1.743 2.146a.88.88 0 01.839.83h.614a1.467 1.467 0 00-1.453-1.435V.918h-.355v.623a1.766 1.766 0 00-.8.251A1.464 1.464 0 00-.073 3.01a1.366 1.366 0 00.614 1.15 4 4 0 00.847.389v2.049a.915.915 0 01-.891-.9.11.11 0 01.009-.052h-.6a.855.855 0 00-.009.13 1.3 1.3 0 00.64 1.133 1.5 1.5 0 00.847.277v.8h.354v-.8a1.861 1.861 0 00.873-.277 1.483 1.483 0 00.692-1.254 1.453 1.453 0 00-.661-1.227 4.322 4.322 0 00-.9-.415zm-.355 1.729c-.588-.2-.839-.467-.839-.9 0-.458.294-.761.839-.83zm.354.821c.631.233.917.536.917.994a.9.9 0 01-.917.908z",
  fill: "#fff"
})));

var SvgCheckPayment = function SvgCheckPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 30,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCheckPayment, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/CheckPayment.a2759e9b.svg";
export { ForwardRef as ReactComponent };